import { useState } from 'react';
import { usePopper } from 'react-popper';
import { Modifier } from '@popperjs/core';

// source: https://popper.js.org/docs/v2/modifiers/community-modifiers/
const sameWidthModifier: Modifier<string, {}> = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({ state }) => {
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  effect: ({ state }) => {
    state.elements.popper.style.width = `${
      (state.elements.reference as any).offsetWidth
    }px`;
  },
};

export const usePopperDropdown = ({
  sameWidth,
  modifiers,
  ...options
}: Parameters<typeof usePopper>[2] & { sameWidth?: boolean } = {}) => {
  const [referenceElement, setReferenceElement] =
    useState<HTMLButtonElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null
  );
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    modifiers: [
      ...(modifiers ?? []),
      ...(sameWidth ? [sameWidthModifier] : []),
    ],
    ...options,
  });

  const referenceElementProps = {
    ref: setReferenceElement,
  };

  const popperElementProps = {
    ref: setPopperElement,
    style: styles.popper,
    ...attributes.popper,
  };

  return {
    referenceElementProps,
    popperElementProps,
  };
};
